module.exports = __webpack_public_path__ + "img/Loner.ec99f0c3.png";